export class QuestionAnswer {
  dataVariableTypeId: string;
  dataVariableDescription: string;
  dataVariableKeyName: string;
  dataVariableOption: (string | number)[];
  dataVariableOptionId: string[];
  dataVariableValueDescription?: string;
  readOnlyInd: boolean;
}
